import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Download } from 'lucide-react';
import CatalogueModal from '../CatalogueModal';

const CategoriesSection = () => {
  const [showCatalogueModal, setShowCatalogueModal] = useState(false);

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">Notre Catalogue</h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto mb-5 md:mb-6">Découvrez notre gamme complète de matériel événementiel</p>
          <button
            onClick={() => setShowCatalogueModal(true)}
            className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500 text-white font-semibold rounded-full hover:bg-orange-600 transition-all shadow-md hover:shadow-lg"
          >
            <Download className="w-5 h-5" />
            Télécharger le Catalogue 2026 (avec les tarifs)
          </button>
        </div>

        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
          {/* Carte 1 - Barnums et Tentes */}
          <Link to="/catalogue/barnums-tentes" className="group relative overflow-hidden rounded-2xl">
            <div className="aspect-[4/3] relative">
              <img src="https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?w=600&h=400&fit=crop" alt="Barnums et Tentes" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <h3 className="text-sm md:text-xl font-bold text-white mb-1 md:mb-2">Barnums et Tentes</h3>
                <p className="text-xs text-gray-200 mb-2 md:mb-3 hidden md:block">Chapiteaux, Tentes pliantes, Plancher de réception</p>
                <span className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-orange-300 group-hover:text-white transition-colors">Découvrir <ChevronRight className="w-3 h-3 md:w-4 md:h-4" /></span>
              </div>
            </div>
          </Link>

          {/* Carte 2 - Mobilier et Décoration */}
          <Link to="/catalogue/mobilier-deco" className="group relative overflow-hidden rounded-2xl">
            <div className="aspect-[4/3] relative">
              <img src="https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=600&h=400&fit=crop" alt="Mobilier et Décoration" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-xl font-bold text-white mb-2">Mobilier et Décoration</h3>
                <p className="text-sm text-gray-200 mb-3">Chaises, tables, bancs, nappes, housses</p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-orange-300 group-hover:text-white transition-colors">Découvrir <ChevronRight className="w-4 h-4" /></span>
              </div>
            </div>
          </Link>

          {/* Carte 3 - Matériel et Accessoires */}
          <Link to="/catalogue/materiel-accessoires" className="group relative overflow-hidden rounded-2xl">
            <div className="aspect-[4/3] relative">
              <img src="https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=600&h=400&fit=crop" alt="Matériel et Accessoires" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <h3 className="text-sm md:text-xl font-bold text-white mb-1 md:mb-2">Matériel et Accessoires</h3>
                <p className="text-xs text-gray-200 mb-2 md:mb-3 hidden md:block">Sonorisation, éclairage, chauffage, ambiance</p>
                <span className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-orange-300 group-hover:text-white transition-colors">Découvrir <ChevronRight className="w-3 h-3 md:w-4 md:h-4" /></span>
              </div>
            </div>
          </Link>

          {/* Carte 4 - Restauration */}
          <Link to="/catalogue/restauration" className="group relative overflow-hidden rounded-2xl">
            <div className="aspect-[4/3] relative">
              <img src="https://images.unsplash.com/photo-1555658636-6e4a36218be7?w=600&h=400&fit=crop" alt="Restauration - Buvette avec tireuses à bière" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <h3 className="text-sm md:text-xl font-bold text-white mb-1 md:mb-2">Restauration et Buvette</h3>
                <p className="text-xs text-gray-200 mb-2 md:mb-3 hidden md:block">Vaisselle, Buvette, animations gourmandes, remorque frigorifique</p>
                <span className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-orange-300 group-hover:text-white transition-colors">Découvrir <ChevronRight className="w-3 h-3 md:w-4 md:h-4" /></span>
              </div>
            </div>
          </Link>

          {/* Carte 5 - Gonflables et Jeux */}
          <Link to="/catalogue/gonflables-jeux" className="group relative overflow-hidden rounded-2xl">
            <div className="aspect-[4/3] relative">
              <img src="https://bucket-prod.getlokki.com/67652562dfe18b126c4da009/images/1740690306661-productImage-67652562dfe18b126c4da009.jpg" alt="Gonflables et Jeux" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <h3 className="text-sm md:text-xl font-bold text-white mb-1 md:mb-2">Gonflables et Jeux</h3>
                <p className="text-xs text-gray-200 mb-2 md:mb-3 hidden md:block">Châteaux gonflables petits et grands, jeux de tir, jeux en bois</p>
                <span className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-orange-300 group-hover:text-white transition-colors">Découvrir <ChevronRight className="w-3 h-3 md:w-4 md:h-4" /></span>
              </div>
            </div>
          </Link>

          {/* Carte 6 - Pack Tout Inclus */}
          <Link to="/catalogue/pack-tout-inclus" className="group relative overflow-hidden rounded-2xl">
            <div className="aspect-[4/3] relative">
              <img src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600&h=400&fit=crop" alt="Pack Tout Inclus" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-orange-900/90 via-orange-900/50 to-transparent" />
              <span className="absolute top-3 right-3 md:top-4 md:right-4 px-2 py-0.5 md:px-3 md:py-1 bg-orange-500 text-white text-[10px] md:text-xs font-bold rounded-full">POPULAIRE</span>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <h3 className="text-sm md:text-xl font-bold text-white mb-1 md:mb-2">Pack Tout Inclus</h3>
                <p className="text-xs text-gray-200 mb-2 md:mb-3 hidden md:block">Formules clés en main</p>
                <span className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-orange-300 group-hover:text-white transition-colors">Découvrir <ChevronRight className="w-3 h-3 md:w-4 md:h-4" /></span>
              </div>
            </div>
          </Link>
        </div>
      </div>

      {/* Catalogue Modal */}
      <CatalogueModal isOpen={showCatalogueModal} onClose={() => setShowCatalogueModal(false)} />
    </section>
  );
};

export default CategoriesSection;
